import React, { Component } from 'react';
import { connect } from 'react-redux';
import _union from 'lodash/union';
import { getHotelsInfo } from 'httpClient/requests/searchResults';
import LandingPageTemplateComponent from './LandingPageTemplateComponent';

function parseScript(description = '') {
  const script = description.match(/<script>(.*)<\/script>/);
  return (script && script[1] && JSON.parse(script[1])) || {};
}

class LandingPageTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      destinations: [],
      hotels: [],
    };

    this.scriptArgs = parseScript(props.content.description);
  }

  componentDidMount() {
    const { destinations } = this.props;
    const { hotelIds, destinationCodes } = this.scriptArgs;

    hotelIds && this.setHotels();
    destinationCodes && destinations.length > 0 && this.setDestinations();
  }

  componentDidUpdate(prevProps) {
    const { destinations } = this.props;
    const { destinationCodes } = this.scriptArgs;

    destinationCodes && prevProps.destinations.length === 0 && destinations.length > 0 && this.setDestinations();
  }

  setDestinations() {
    const { destinations } = this.props;
    const { destinationCodes } = this.scriptArgs;

    this.setState({
      destinations: destinations
        .map(({ destinations }) => destinations)
        .reduce((accumulator, destinations) => _union(accumulator, destinations))
        .filter(({ code }) => destinationCodes.indexOf(code) !== -1),
    });
  }

  setHotels() {
    const { hotelIds } = this.scriptArgs;

    getHotelsInfo({ hotels: hotelIds })
      .then(({ data }) => {
        this.setState({
          hotels: data,
        });
      })
      .catch((error) => console.error(error));
  }

  render() {
    const { description, featuredImage } = this.props.content;
    const { destinations, hotels } = this.state;

    return (
      <LandingPageTemplateComponent
        image={featuredImage}
        description={description}
        destinations={destinations}
        hotels={hotels}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    destinations: state.selectDestinations.destinations,
  };
}

export default connect(mapStateToProps)(LandingPageTemplate);
